import React from 'react'
import { Box } from '../box'
import Icon from '../../../images/toast_info.svg'

export const InfoIcon = () => {
  return (
    <Box>
      <img src={Icon} width={20} height={20} alt="info" />
    </Box>
  )
}
